import { useEffect } from 'react';
import Typography from '../../Atoms/Typography';
import { Icon } from '../../Icons';
import { Controlled as CodeMirror } from 'react-codemirror2';

// import 'codemirror/lib/codemirror.css';
// import 'codemirror/theme/material.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/night.css';
import 'codemirror/mode/yaml/yaml';
// import 'code-mirror-themes/themes/made-of-code.css';
import 'codemirror/theme/neat.css';
import 'codemirror/addon/fold/foldgutter.css';
import ZohoChatSupport from '../../Common/ZohoChartSupport';
import useOnboardingConfiguration from '../../../hooks/Onboarding/configureTest';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tab } from '@headlessui/react';
import ViewTestResult from '../ViewTestResult';
import { onlyWindowsSupportedFramework } from '../../../utils/onboarding/languageBasedConfig';
import history from 'utils/history';
import ReactTooltip from 'react-tooltip';
import { sendAmplitudeEvents } from '../../../utils/common';
import { EventNames } from '../../../utils/events';

import { isEnterPressed } from 'utils/keyboard';
import { Path } from 'constants/routes';
import isEnterOrSpacePressed from 'utils/isEnterOrSpacePressed';
import setTitle from 'utils/setTitle';
import './index.css';

const PROJECT_SETUP_TYPES = [
  { name: 'Direct Download', index: 0 },
  { name: 'Clone', index: 1 },
];

const CodeMirrorDefaultOption = {
  mode: 'text/x-yaml',
  lineWrapping: true,
  indentWithTabs: false,
  lint: {
    highlightLines: true,
  },
  gutters: ['CodeMirror-lint-markers'],
};

const MaterialOption = {
  ...CodeMirrorDefaultOption,
  theme: 'material',
  lineNumbers: false,
};

const ThemeOption = {
  ...CodeMirrorDefaultOption,
  theme: 'mytheme',
  lineNumbers: true,
};

let SUPPORTED_OS = [
  { name: 'Windows', key: 'win', index: 0, icon: 'onboard/windows' },
  { name: 'Linux', key: 'linux', index: 1, icon: 'onboard/linux' },
];
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function onGoBack() {
  window.history.state
    ? history.goBack()
    : history.push(Path.QUICK_START, {
        previous_page: Path.QUICK_START_CONFIGURE_TEST.Path,
      });
}

function ConfigureTest() {
  let {
    updateYaml,
    currentConfiguration,
    currentFramework,
    setupProjectDownload,
    downloadConcierge,
    getCommandToRunTest,
    getYamlCode,
    textCopiedType,
    copyBtnClicked,
    downloadYaml,
    //for download tab switch
    currentSetupTab,
    setCurrentSetupTab,
    getSystemOsIcon,
    getSystemOsName,
    systemOS,
    getOthersOS,
    currentYamlOsSelection,
    platformChange,
    resetDownloadCociergeAlert,
    visual,
    getConciergeURL,
    yamlCopied,
    yamlDownloaded,
    updateYamlCopyAlertStatus,
    updateCompletedSteps,
    handleViewInGithub,
  } = useOnboardingConfiguration();

  useEffect(() => {
    setTitle('run-on-local');
  }, []);

  function handleTextAriaLabel() {
    const textArias = document.getElementsByTagName('textarea');
    for (let item of textArias) {
      item?.setAttribute('tabIndex', '-2');
      item?.setAttribute('disabled', 'true');
      item?.setAttribute('aria-label', 'yaml-code-aria');
    }
  }

  function isDisabled(index = 0) {
    return (
      currentConfiguration.completedSteps.indexOf(index) === -1 &&
      currentConfiguration.currentStep !== index
    );
  }

  useEffect(() => {
    const yamlElement = document.getElementsByClassName('CodeMirror-scroll')[0];
    yamlElement?.setAttribute('tabIndex', 0);
    handleTextAriaLabel();
  }, []);

  useEffect(() => {
    handleTextAriaLabel();
  }, [currentSetupTab]);

  if (
    onlyWindowsSupportedFramework.indexOf(
      currentConfiguration &&
        currentConfiguration.framework &&
        currentConfiguration.framework.name
    ) !== -1
  ) {
    SUPPORTED_OS = [
      { name: 'Windows', key: 'win', index: 0, icon: 'onboard/windows' },
    ];
  } else {
    SUPPORTED_OS = [
      { name: 'Windows', key: 'win', index: 0, icon: 'onboard/windows' },
      { name: 'Linux', key: 'linux', index: 1, icon: 'onboard/linux' },
    ];
  }
  let githubLink =
    currentFramework &&
    currentFramework.setupGit &&
    currentFramework.setupGit.clone.split(' ');
  if (githubLink.length) {
    githubLink = githubLink[2];
  }
  return (
    <div className="ltw-bg-group-list-bg-color ltw-py-20px ltw-ml-15px run-on-local-page-container">
      <ReactTooltip id="configure-test" html={true} />
      <div className="ltw-flex ltw-items-center ltw-justify-between">
        <div className="ltw-mb-11px ltw-flex ltw-items-center">
          <div
            onClick={onGoBack}
            onKeyDown={(e) => isEnterOrSpacePressed(e) && onGoBack(e)}
            role="button"
            tabIndex="0"
          >
            <Icon
              name={'back-icon'}
              width="10"
              height="16"
              className={'ltw-mr-18px ltw-inline-block ltw-cursor-pointer'}
            />
          </div>

          <Typography
            variant="h2"
            fontSize="ltw-text-18"
            lineHeight="ltw-leading-22"
            fontType="ltw-font-semibold"
            color="ltw-text-black"
          >
            Configure your{' '}
            {currentConfiguration &&
              currentConfiguration.framework &&
              currentConfiguration.framework.name}{' '}
            script with HyperExecute
          </Typography>
        </div>
        <div className="ltw-flex ltw-justify-between ltw-gap-15px">
          <ZohoChatSupport />
        </div>
      </div>
      <div className="ltw-flex ltw-relative">
        <div
          className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ltw-mt-40px ${
            currentConfiguration.completedSteps.indexOf(1) !== -1
              ? 'hyp-stepper-border'
              : 'ltw-border-gray-7'
          }`}
        >
          <span
            className={`ltw-border-2 ltw-rounded-5px  ${
              currentConfiguration.currentStep === 1 ||
              currentConfiguration.completedSteps.indexOf(1) !== -1
                ? 'gray-666'
                : 'ltw-border-gray-7'
            } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
              currentConfiguration.completedSteps.indexOf(1) !== -1
                ? 'hyp-stepper-color'
                : ' ltw-bg-white'
            } `}
          ></span>
        </div>
        <div
          className={`ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex ltw-flex-1 ${
            currentConfiguration.currentStep === 1
              ? 'ltw-border ltw-border-0.5 hyp-stepper-border'
              : ''
          } ltw-min-h-145px`}
        >
          <div className="ltw-flex-1">
            <div className="ltw-flex ltw-gap-8px ltw-items-center">
              <Typography
                variant="h2"
                fontType="ltw-font-medium"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-16"
                color="ltw-text-black"
              >
                Download Sample Project
              </Typography>
            </div>
            <Typography
              variant="subtext-1"
              fontType="ltw-font-normal"
              className="ltw-tracking-widest gray-666"
              fontSize="ltw-text-12"
              lineHeight="ltw-leading-19"
              mt="5px"
            >
              Please download the sample project
            </Typography>
            <div className="ltw-mt-30px ltw-cursor-pointer">
              <a
                target="__blank"
                style={{
                  textDecoration: 'underline',
                  textDecorationColor: '#101010',
                }}
                role="button"
                tabIndex="0"
                href="/#"
                onClick={handleViewInGithub(githubLink)}
              >
                <Typography
                  variant="subtext-1"
                  fontType="ltw-font-normal"
                  className="ltw-tracking-widest gray-101"
                  fontSize="ltw-text-13"
                  lineHeight="ltw-leading-19"
                  cursor="pointer"
                >
                  View in
                  <Icon
                    name="github"
                    width="14px"
                    height="14xpx"
                    className={'ltw-mx-4px ltw-inline-block ltw-mb-3px'}
                    color="#101010"
                  />
                  GitHub
                  <Icon
                    name={'expand'}
                    width="10"
                    height="16"
                    className={'ltw-mx-4px ltw-inline-block'}
                    color="#101010"
                  />
                </Typography>
              </a>
            </div>
          </div>
          <div className="ltw-flex-1">
            <Tab.Group
              manual
              defaultIndex={currentSetupTab}
              onChange={(index) => {
                setCurrentSetupTab(index);
              }}
            >
              <Tab.List className="ltw-flex">
                {PROJECT_SETUP_TYPES.map((setuptype, index) => (
                  <Tab
                    key={index}
                    className={({ selected }) =>
                      classNames(
                        'ltw-py-12px ltw-pl-10px ltw-pr-20px',
                        index === currentSetupTab
                          ? 'ltw-border-b ltw-border-black'
                          : 'ltw-border-b ltw-border-gray-11'
                      )
                    }
                  >
                    {({ selected }) => (
                      <div className="ltw-flex ltw-gap-5px ltw-items-center">
                        <Typography
                          variant="p"
                          color={
                            index === currentSetupTab
                              ? 'ltw-text-onboard-heading'
                              : 'ltw-text-black-secondary'
                          }
                          fontType="ltw-font-normal"
                          cursor="pointer"
                        >
                          {setuptype.index === 1 && (
                            <Icon
                              name="github"
                              width="16px"
                              height="16px"
                              className={'ltw-mr-10px ltw-inline-block'}
                              color={
                                index === currentSetupTab
                                  ? '#000000'
                                  : '#666666'
                              }
                            />
                          )}
                          {setuptype.name}
                        </Typography>
                      </div>
                    )}
                  </Tab>
                ))}
              </Tab.List>
              <Tab.Panels className="ltw-mt-14px">
                {currentSetupTab === 0 && (
                  <button
                    onClick={(e) => setupProjectDownload('zip')}
                    className={
                      'ltw-flex ltw-items-center ltw-bg-transparent ltw-border  ltw-rounded ltw-px-10px ltw-py-6px onboarding-cta-btn onboarding-cta-btn-code-sample'
                    }
                  >
                    <Typography
                      variant="p"
                      fontSize="ltw-text-13"
                      lineHeight="ltw-leading-13"
                      fontType="ltw-font-normal"
                      cursor="pointer"
                      extraClasses="ltw-flex"
                      className="code-sample-button-text"
                    >
                      Code Sample
                    </Typography>
                    <Icon
                      name="download-icon"
                      width="10px"
                      height="12px"
                      color="#101010"
                      className={'ltw-ml-6px ltw-inline-block'}
                    />
                  </button>
                )}
                {currentSetupTab === 1 && (
                  <div className="ltw-relative">
                    <div className="ltw-absolute ltw-top-15px ltw-right-10px ltw-z-10 ltw-cursor-pointer">
                      {textCopiedType !== 'setup' ? (
                        <CopyToClipboard
                          data-tip="Copy"
                          data-for="configure-test"
                          text={currentFramework.setupGit.clone}
                          onCopy={() => {
                            copyBtnClicked('setup');
                            setupProjectDownload('git', currentFramework);
                          }}
                        >
                          <div>
                            <div
                              className="ltw-flex ltw-gap-5px ltw-items-center"
                              data-tip="Copy"
                              data-for="configure-test"
                            >
                              <Icon
                                name="copy-icon"
                                width="14px"
                                height="14px"
                              />
                            </div>
                          </div>
                        </CopyToClipboard>
                      ) : (
                        <div className=" ltw-bg-green-color-copied ltw-rounded ltw-py-2px ltw-px-10px ltw-flex ltw-justify-center  ltw-max-w-220px ltw-cursor-pointer">
                          <div className="ltw-flex ltw-justify-center">
                            <Typography
                              variant="subtext-1"
                              color="ltw-text-black-regular"
                              cursor="pointer"
                              fontType="ltw-font-normal"
                            >
                              Copied
                            </Typography>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="github-clone-code github-clone-code-try-example">
                      <CodeMirror
                        value={currentFramework.setupGit.clone}
                        options={MaterialOption}
                        onChange={(editor, data, value) => {}}
                      />
                    </div>
                  </div>
                )}
              </Tab.Panels>
            </Tab.Group>
            {currentConfiguration.currentStep === 1 && (
              <div
                onClick={(e) => {
                  updateCompletedSteps(1, 2);
                  sendAmplitudeEvents(
                    EventNames.HYP_ONBOARDING_SKIP_STEPS_SAMPLE,
                    {
                      step: 'download sample project',
                    }
                  );
                }}
                onKeyDown={(e) => {
                  isEnterPressed(e) && updateCompletedSteps(1, 2);
                }}
                role="button"
                tabIndex="0"
                className={'ltw-flex ltw-justify-end ltw-mt-5px'}
              >
                <Typography
                  variant="h2"
                  fontSize="ltw-text-10"
                  lineHeight="ltw-leading-12"
                  fontType="ltw-font-semibold"
                  cursor="pointer"
                  extraClasses="ltw-flex ltw-uppercase ltw-tracking-1.5px gray-101 "
                >
                  Skip
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="ltw-flex ltw-relative"
        disableddiv={isDisabled(2) ? 'disabled' : 'false'}
        aria-disabled={isDisabled(2) ? true : false}
      >
        <div
          className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ${
            currentConfiguration.completedSteps.indexOf(2) !== -1
              ? 'hyp-stepper-border'
              : 'ltw-border-gray-7'
          }`}
        >
          <span
            className={`ltw-border-2 ltw-rounded-5px ${
              currentConfiguration.currentStep === 2 ||
              currentConfiguration.completedSteps.indexOf(2) !== -1
                ? 'hyp-stepper-border'
                : 'ltw-border-gray-7'
            } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
              currentConfiguration.completedSteps.indexOf(2) !== -1
                ? 'hyp-stepper-color'
                : ' ltw-bg-white'
            } ltw-mt-40px`}
          ></span>
        </div>
        <div
          className={`ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex ltw-items-center ltw-flex-1 ${
            currentConfiguration.currentStep === 2
              ? 'ltw-border ltw-border-0.5 hyp-stepper-border'
              : ''
          }`}
        >
          <div className="ltw-flex-1">
            <div className="ltw-flex ltw-gap-8px ltw-items-center">
              <Typography
                variant="h2"
                fontType="ltw-font-medium"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-16"
                color="ltw-text-black"
              >
                Download{' '}
                <a
                  className="gray-101 hyperexecute-cli-link-text"
                  href={process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK}
                  target="_blank"
                  rel="noreferrer"
                >
                  HyperExecute CLI
                </a>
              </Typography>
            </div>
            <Typography
              variant="subtext-1"
              fontType="ltw-font-normal"
              className="ltw-tracking-widest gray-666"
              fontSize="ltw-text-12"
              lineHeight="ltw-leading-19"
              mt="5px"
            >
              CLI is a command line interface to interact and run tests. It is
              recommended to <br></br>place the CLI in the project root
              directory.
            </Typography>
          </div>
          <div className="ltw-flex-1 download-cli-options">
            <div className="ltw-flex ltw-items-center ltw-flex-wrap ltw-gap-30px">
              <div className="ltw-flex ltw-items-center ltw-gap-12px">
                <a
                  onClick={(e) => downloadConcierge(systemOS)}
                  href={getConciergeURL(systemOS)}
                  className={
                    'ltw-flex ltw-items-center ltw-border  ltw-rounded ltw-px-10px ltw-py-6px onboarding-cta-btn onboarding-cta-btn-code-sample'
                  }
                >
                  <Icon
                    name={getSystemOsIcon()}
                    width="14px"
                    height="16px"
                    color="#101010"
                    className={'ltw-mr-8px ltw-inline-block'}
                  />
                  <Typography
                    variant="p"
                    fontSize="ltw-text-13"
                    lineHeight="ltw-leading-13"
                    fontType="ltw-font-normal"
                    cursor="pointer"
                    extraClasses="ltw-flex code-sample-button-text"
                  >
                    {getSystemOsName()}
                  </Typography>
                  <Icon
                    name="download-icon"
                    width="10px"
                    height="12px"
                    color="#101010"
                    className={'ltw-ml-6px ltw-inline-block'}
                  />
                </a>
              </div>
              <div className="ltw-flex ltw-gap-11px ltw-items-center">
                <Typography
                  variant="p"
                  fontType="ltw-font-normal"
                  fontSize="ltw-text-12"
                  lineHeight="ltw-leading-14"
                  color="ltw-text-black-secondary"
                >
                  Other OS?
                </Typography>
                <div className="ltw-flex ltw-gap-8px ltw-items-center">
                  {getOthersOS().map((osName, index) => {
                    return (
                      <a
                        className="ltw-flex ltw-items-center ltw-gap-8px ltw-bg-gray-btn ltw-px-10px ltw-py-6px ltw-rounded platformaBtn"
                        onClick={(e) => downloadConcierge(osName)}
                        href={getConciergeURL(osName)}
                        aria-label="download-concierge-icon"
                      >
                        <Icon
                          name={getSystemOsIcon(osName)}
                          width="14px"
                          height="16px"
                        />
                        <span className="otherOsName">
                          <Typography
                            variant="h2"
                            color="ltw-black-secondary"
                            fontSize="ltw-text-13"
                            lineHeight="ltw-leading-13"
                            fontType="ltw-font-normal"
                            cursor="pointer"
                            extraClasses="ltw-flex"
                          >
                            {getSystemOsName(osName)}
                          </Typography>
                        </span>
                        <span className="otherOsName">
                          <Icon
                            name="download-icon"
                            width="10px"
                            height="12px"
                            color="#666666"
                          />
                        </span>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
            {currentConfiguration.currentStep === 2 && (
              <div
                onClick={(e) => {
                  updateCompletedSteps(2, 3);
                  sendAmplitudeEvents(
                    EventNames.HYP_ONBOARDING_SKIP_STEPS_SAMPLE,
                    {
                      step: 'download hyperexecute cli',
                    }
                  );
                }}
                onKeyDown={(e) => {
                  isEnterPressed(e) && updateCompletedSteps(2, 3);
                }}
                role="button"
                tabIndex="0"
                className={'ltw-flex ltw-justify-end'}
              >
                <Typography
                  variant="h2"
                  fontSize="ltw-text-10"
                  lineHeight="ltw-leading-12"
                  fontType="ltw-font-semibold"
                  cursor="pointer"
                  extraClasses="ltw-flex ltw-uppercase ltw-tracking-1.5px gray-101 "
                >
                  Skip
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="ltw-flex ltw-relative"
        disableddiv={isDisabled(3) ? 'disabled' : 'false'}
        aria-disabled={isDisabled(3) ? true : false}
      >
        <div
          className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ${
            currentConfiguration.completedSteps.indexOf(3) !== -1
              ? 'hyp-stepper-border'
              : 'ltw-border-gray-7'
          }`}
        >
          <span
            className={`ltw-border-2 ltw-rounded-5px ${
              currentConfiguration.currentStep === 3 ||
              currentConfiguration.completedSteps.indexOf(3) !== -1
                ? 'hyp-stepper-border'
                : 'ltw-border-gray-7'
            } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
              currentConfiguration.completedSteps.indexOf(2) !== -1
                ? 'hyp-stepper-color'
                : ' ltw-bg-white'
            } ltw-mt-40px`}
          ></span>
        </div>
        <div className="ltw-flex-1">
          <div
            className={`ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex ltw-flex-1 ${
              currentConfiguration.currentStep === 3
                ? 'ltw-border ltw-border-0.5 hyp-stepper-border'
                : ''
            }`}
          >
            <div className="ltw-flex-1">
              <div className="ltw-flex ltw-gap-8px ltw-items-center">
                <Typography
                  variant="h2"
                  fontType="ltw-font-medium"
                  fontSize="ltw-text-15"
                  lineHeight="ltw-leading-16"
                  color="ltw-text-black"
                >
                  Operating System (OS) selection
                </Typography>
              </div>
              <Typography
                variant="subtext-1"
                fontType="ltw-font-normal"
                className="ltw-tracking-widest gray-666"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-19"
                mt="5px"
              >
                Choose the preferred OS on which you would like to run the tests
              </Typography>
            </div>
            <div className="ltw-flex-1">
              <div className="sampletest-yaml-container">
                <Tab.Group
                  manual
                  defaultIndex={currentYamlOsSelection}
                  onChange={(index) => {
                    platformChange(index);
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_OS_SELECTION_SAMPLE,
                      { os: index === 0 ? 'win' : 'linux' }
                    );
                  }}
                >
                  <Tab.List className="ltw-border-b ltw-border-black-light-2">
                    {SUPPORTED_OS.map((os, index) => {
                      return (
                        <Tab
                          key={index}
                          className={({ selected }) =>
                            classNames(
                              'ltw-py-12px ltw-px-10px',
                              os.index === currentYamlOsSelection
                                ? 'ltw-border-b ltw-border-white'
                                : ''
                            )
                          }
                        >
                          {({ selected }) => (
                            <div className="ltw-flex ltw-gap-8px ltw-items-center">
                              <Icon
                                name={os.icon}
                                width="16px"
                                height="16px"
                                className={'ltw-mx-5px ltw-inline-block'}
                                color={
                                  os.index === currentYamlOsSelection
                                    ? 'white'
                                    : ''
                                }
                              />
                              <Typography
                                variant="p"
                                color={
                                  os.index === currentYamlOsSelection
                                    ? 'ltw-text-white configure-yaml-selected-os'
                                    : 'ltw-text-gray-10'
                                }
                                fontType="ltw-font-normal"
                                cursor="pointer"
                              >
                                {os.name}
                              </Typography>
                            </div>
                          )}
                        </Tab>
                      );
                    })}
                  </Tab.List>
                  <Tab.Panels>
                    <div className="yml-container ltw-relative">
                      <div className="ltw-absolute ltw-top-15px ltw-right-30px ltw-z-10 ltw-cursor-pointer">
                        {textCopiedType !== 'yaml' ? (
                          <div className="ltw-flex ltw-gap-15px">
                            <CopyToClipboard
                              text={getYamlCode(currentFramework.yamlCode)}
                              onCopy={() => {
                                copyBtnClicked('yaml');
                                sendAmplitudeEvents(
                                  EventNames.HYP_ONBOARDING_COPY_YAML_CODE_SAMPLE,
                                  {
                                    os: currentConfiguration?.platform,
                                    getBy: 'copy',
                                  }
                                );
                              }}
                            >
                              <div
                                className="ltw-flex ltw-items-center"
                                data-tip="Copy"
                                data-for="configure-test"
                              >
                                <Icon
                                  name="copy-icon"
                                  width="14px"
                                  height="14px"
                                />
                              </div>
                            </CopyToClipboard>
                            <div
                              className="ltw-flex ltw-items-center"
                              onClick={(e) => {
                                downloadYaml(
                                  getYamlCode(currentFramework.yamlCode)
                                );
                                sendAmplitudeEvents(
                                  EventNames.HYP_ONBOARDING_COPY_YAML_CODE_SAMPLE,
                                  {
                                    os: currentConfiguration?.platform,
                                    getBy: 'download',
                                  }
                                );
                              }}
                              onKeyDown={(e) =>
                                isEnterPressed(e) &&
                                downloadYaml(
                                  getYamlCode(currentFramework.yamlCode)
                                )
                              }
                              role="button"
                              tabIndex="0"
                              data-tip="Download"
                              data-for="configure-test"
                              aria-label="yaml-download-button"
                            >
                              <Icon
                                name="download-code-icon"
                                width="12px"
                                height="14px"
                              />
                            </div>
                          </div>
                        ) : (
                          <div className=" ltw-bg-green-color-copied ltw-rounded ltw-py-5px ltw-px-10px ltw-flex ltw-justify-center  ltw-max-w-220px ltw-cursor-pointer">
                            <div className="ltw-flex ltw-justify-center">
                              <Typography
                                variant="subtext-1"
                                color="ltw-text-black-regular"
                                cursor="pointer"
                                fontType="ltw-font-normal"
                              >
                                Copied
                              </Typography>
                            </div>
                          </div>
                        )}
                      </div>
                      <CodeMirror
                        value={getYamlCode(currentFramework.yamlCode)}
                        options={ThemeOption}
                        onBeforeChange={(editor, data, value) => {
                          updateYaml(value);
                        }}
                        onChange={(editor, data, value) => {
                          updateYaml(value);
                        }}
                      />
                    </div>
                  </Tab.Panels>
                </Tab.Group>
              </div>
              {currentConfiguration.currentStep === 3 && (
                <div
                  onClick={(e) => {
                    updateCompletedSteps(3, 4);
                  }}
                  onKeyDown={(e) => {
                    isEnterPressed(e) && updateCompletedSteps(3, 4);
                  }}
                  role="button"
                  tabIndex="0"
                  className="sampletest-yaml-skip"
                >
                  <Typography
                    variant="h2"
                    fontSize="ltw-text-10"
                    lineHeight="ltw-leading-12"
                    fontType="ltw-font-semibold"
                    cursor="pointer"
                    extraClasses="ltw-flex ltw-uppercase ltw-tracking-1.5px gray-101"
                  >
                    Skip
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="ltw-flex ltw-relative"
        disableddiv={isDisabled(4) ? 'disabled' : 'false'}
        aria-disabled={isDisabled(4) ? true : false}
      >
        <div
          className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ltw-mb-50px ${
            currentConfiguration.completedSteps.indexOf(4) !== -1
              ? 'hyp-stepper-border'
              : 'ltw-border-gray-7'
          }`}
        >
          <span
            className={`ltw-border-2 ltw-rounded-5px ${
              currentConfiguration.currentStep === 4 ||
              currentConfiguration.completedSteps.indexOf(4) !== -1
                ? 'hyp-stepper-border'
                : 'ltw-border-gray-7'
            } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
              currentConfiguration.completedSteps.indexOf(4) !== -1
                ? 'hyp-stepper-color'
                : ' ltw-bg-white'
            } ltw-mt-40px`}
          ></span>
        </div>
        <div
          className={`ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex ltw-flex-1 ${
            currentConfiguration.currentStep === 4
              ? 'ltw-border ltw-border-0.5 hyp-stepper-border'
              : ''
          }`}
        >
          <div className="ltw-flex-1">
            <div className="ltw-flex ltw-gap-8px ltw-items-center">
              <Typography
                variant="h2"
                fontType="ltw-font-medium"
                fontSize="ltw-text-15"
                color="ltw-text-black"
                lineHeight="ltw-leading-16"
              >
                Execution with HyperExecute CLI
              </Typography>
            </div>
            <Typography
              variant="subtext-1"
              fontType="ltw-font-normal"
              className="ltw-tracking-widest gray-666"
              fontSize="ltw-text-12"
              lineHeight="ltw-leading-19"
              mt="5px"
            >
              Trigger the following command on the terminal
            </Typography>
            {(yamlCopied || yamlDownloaded) && (
              <div className="ltw-bg-red-bg ltw-px-16px ltw-py-9px ltw-mt-8px ltw-mr-50px">
                {yamlCopied && (
                  <Typography
                    variant="subtext-1"
                    color="failed-red"
                    fontType="ltw-font-normal"
                    className="ltw-tracking-widest"
                    fontSize="ltw-text-12"
                    lineHeight="ltw-leading-19"
                    mt="5px"
                  >
                    <Icon
                      name="info-blue"
                      width="14px"
                      height="14px"
                      color="#FF7663"
                      className="ltw-mb-2px ltw-inline-block ltw-mr-6px"
                    />
                    Please ensure that you put your yaml in the root directory
                    of your project and provide the exact yaml file name in the
                    execute script.
                  </Typography>
                )}
                {yamlDownloaded && (
                  <Typography
                    variant="subtext-1"
                    color="failed-red"
                    fontType="ltw-font-normal"
                    className="ltw-tracking-widest"
                    fontSize="ltw-text-12"
                    lineHeight="ltw-leading-19"
                    mt="5px"
                  >
                    <Icon
                      name="info-blue"
                      width="14px"
                      height="14px"
                      color="#FF7663"
                      className="ltw-mb-2px ltw-inline-block ltw-mr-6px"
                    />
                    Please ensure that you put your yaml in the root directory
                    of your project and if renaming it please change the yaml
                    file name in the execute script. By default the file gets
                    downloaded by the name of hyperexecute.yaml
                  </Typography>
                )}
              </div>
            )}
          </div>
          <div className="ltw-flex-1 ltw-relative">
            <div className="ltw-absolute ltw-top-15px ltw-right-10px ltw-z-10 ltw-cursor-pointer">
              {textCopiedType !== 'conciergeCmd' ? (
                <CopyToClipboard
                  data-tip="Copy"
                  data-for="configure-test"
                  text={getCommandToRunTest(currentFramework.runTestCommand)}
                  onCopy={() => {
                    copyBtnClicked('conciergeCmd');
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_COPY_EXECUTE_CMD_SAMPLE,
                      {
                        copied: getCommandToRunTest(
                          currentFramework.runTestCommand
                        ),
                      }
                    );
                  }}
                >
                  <div className="ltw-flex ltw-gap-5px ltw-items-center">
                    <Icon name="copy-icon" width="14px" height="14px" />
                  </div>
                </CopyToClipboard>
              ) : (
                <div className=" ltw-bg-green-color-copied ltw-rounded ltw-py-2px ltw-px-10px ltw-flex ltw-justify-center  ltw-max-w-220px ltw-cursor-pointer">
                  <div className="ltw-flex ltw-justify-center">
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-black-regular"
                      cursor="pointer"
                      fontType="ltw-font-normal"
                    >
                      Copied
                    </Typography>
                  </div>
                </div>
              )}
            </div>
            <div className="github-clone-code github-clone-code-try-example">
              <CodeMirror
                value={getCommandToRunTest(currentFramework.runTestCommand)}
                options={MaterialOption}
                onChange={(editor, data, value) => {}}
              />
            </div>
          </div>
        </div>
      </div>
      <ViewTestResult />
      {visual && visual.conciergeDownloadAlert && (
        <div className="ltw-fixed ltw-bottom-20px ltw-flex ltw-items-end ltw-gap-20px">
          <Icon name={'quick-start'} width="57" height="68" />
          <div className="ltw-rounded-lg ltw-border ltw-border-secondary ltw-bg-white ltw-w-336px quickStart">
            <div className="ltw-flex ltw-justify-between ltw-bg-secondary ltw-p-15px ltw-gap-5px ltw-items-center">
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontType="ltw-font-semibold"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-18"
              >
                You have downloaded the CLI for{' '}
                {getSystemOsName(currentConfiguration.conciergePlatform)}
              </Typography>
              <Icon
                name={'close-white'}
                width="14"
                height="16"
                onClick={(e) => {
                  resetDownloadCociergeAlert(false);
                }}
                className="ltw-cursor-pointer"
              />
            </div>
            <div className="ltw-px-20px ltw-py-18px">
              <Typography
                variant="h2"
                color="ltw-text-black-secondary-2"
                fontType="ltw-font-normal"
                fontSize="ltw-text-13"
                lineHeight="ltw-leading-19"
              >
                To make it Executable, please run the following command -
                <b> chmod u+x hyperexecute</b>
              </Typography>
            </div>
            <button
              onClick={(e) => {
                resetDownloadCociergeAlert(false);
              }}
              className="ltw-bg-transparent ltw-border hyp-stepper-border hyp-stepper-color ltw-rounded ltw-px-15px ltw-py-8px ltw-ml-20px ltw-mb-18px"
            >
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-12"
                cursor="pointer"
              >
                Okay
              </Typography>
            </button>
          </div>
        </div>
      )}
      {visual && visual.yamlCodeCopiedAlert && (
        <div className="ltw-fixed ltw-bottom-20px ltw-flex ltw-items-end ltw-gap-20px">
          <Icon name={'support-icon'} width="100" height="100" />
          <div className="ltw-rounded-lg ltw-border ltw-border-secondary ltw-bg-white ltw-w-336px quickStart">
            <div className="ltw-flex ltw-justify-between ltw-bg-secondary ltw-p-15px ltw-gap-5px ltw-items-center">
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontType="ltw-font-semibold"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-18"
              >
                We're here to help
              </Typography>
              <Icon
                name={'close-white'}
                width="14"
                height="16"
                onClick={(e) => {
                  updateYamlCopyAlertStatus({ yamlCodeCopiedAlert: false });
                }}
                className="ltw-cursor-pointer"
              />
            </div>
            <div className="ltw-px-20px ltw-py-18px">
              <Typography
                variant="h2"
                color="ltw-text-black-secondary-2"
                fontType="ltw-font-normal"
                fontSize="ltw-text-13"
                lineHeight="ltw-leading-19"
              >
                Please ensure that you put your yaml in the root directory of
                your project and provide the exact yaml file name in the execute
                script.
              </Typography>
            </div>
            <button
              onClick={(e) => {
                updateYamlCopyAlertStatus({ yamlCodeCopiedAlert: false });
              }}
              className="ltw-bg-transparent ltw-border hyp-stepper-border hyp-stepper-color ltw-rounded ltw-px-15px ltw-py-8px ltw-ml-20px ltw-mb-18px"
            >
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-12"
                cursor="pointer"
              >
                Okay
              </Typography>
            </button>
          </div>
        </div>
      )}
      {visual && visual.yamlCodeDownloadedAlert && (
        <div className="ltw-fixed ltw-bottom-20px ltw-flex ltw-items-end ltw-gap-20px">
          <Icon name={'support-icon'} width="100" height="100" />
          <div className="ltw-rounded-lg ltw-border ltw-border-secondary ltw-bg-white ltw-w-336px quickStart">
            <div className="ltw-flex ltw-justify-between ltw-bg-secondary ltw-p-15px ltw-gap-5px ltw-items-center">
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontType="ltw-font-semibold"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-18"
              >
                We're here to help
              </Typography>
              <Icon
                name={'close-white'}
                width="14"
                height="16"
                onClick={(e) => {
                  updateYamlCopyAlertStatus({ yamlCodeDownloadedAlert: false });
                }}
                className="ltw-cursor-pointer"
              />
            </div>
            <div className="ltw-px-20px ltw-py-18px">
              <Typography
                variant="h2"
                color="ltw-text-black-secondary-2"
                fontType="ltw-font-normal"
                fontSize="ltw-text-13"
                lineHeight="ltw-leading-19"
              >
                Please ensure that you put your yaml in the root directory of
                your project and if renaming it please change the yaml file name
                in the execute script.
              </Typography>
            </div>
            <button
              onClick={(e) => {
                updateYamlCopyAlertStatus({ yamlCodeDownloadedAlert: false });
              }}
              className="ltw-bg-transparent ltw-border hyp-stepper-border hyp-stepper-color ltw-rounded ltw-px-15px ltw-py-8px ltw-ml-20px ltw-mb-18px"
            >
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-12"
                cursor="pointer"
              >
                Okay
              </Typography>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default ConfigureTest;
